import FulfillmentOmsIndex from "@/components/oms/fulfillment/FulfillmentOmsIndex.vue";
import FulfillmentOmsAdd from "@/components/oms/fulfillment/FulfillmentOmsAdd.vue";
import FulfillmentOmsDetail from "@/components/oms/fulfillment/FulfillmentOmsDetail.vue";
import FulfillmentOmsEdit from "@/components/oms/fulfillment/FulfillmentOmsEdit.vue";
import FulfillmentOmsUpload from "@/components/oms/fulfillment/FulfillmentOmsUpload.vue";

let routesFulfillmentOmsAccess= [
    {
        path: '',
        meta: {
          title: "List Fulfillment Access",
        },
        name: "FulfillmentOmsIndex",
        component: FulfillmentOmsIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Fulfillment Access",
        },
        name: "FulfillmentOmsAdd",
        component: FulfillmentOmsAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Fulfillment Access",
        },
        name: "FulfillmentOmsDetail",
        component: FulfillmentOmsDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Fulfillment Access",
        },
        name: "FulfillmentOmsEdit",
        component: FulfillmentOmsEdit
    },
     
    {
        path: 'upload',
        meta: {
          title: "Upload Fulfillment Access",
        },
        name: "FulfillmentOmsUpload",
        component: FulfillmentOmsUpload
    },
    
]

export default routesFulfillmentOmsAccess
  